import { Country } from '../country/country';

export enum Currency {
  Australia = 'AUD',
  Canada = 'CAD',
  Malaysia = 'MYR',
  NewZealand = 'NZD',
  Qatar = 'QAR',
  SaudiArabia = 'SAR',
  Singapore = 'SGD',
  UnitedArabEmirates = 'AED',
  UnitedKingdom = 'GBP',
  UnitedStates = 'USD',
}

export const CountryCurrency = {
  [Country.Australia]: Currency.Australia,
  [Country.Canada]: Currency.Canada,
  [Country.Malaysia]: Currency.Malaysia,
  [Country.NewZealand]: Currency.NewZealand,
  [Country.Qatar]: Currency.Qatar,
  [Country.SaudiArabia]: Currency.SaudiArabia,
  [Country.Singapore]: Currency.Singapore,
  [Country.UnitedArabEmirates]: Currency.UnitedArabEmirates,
  [Country.UnitedKingdom]: Currency.UnitedKingdom,
  [Country.UnitedStates]: Currency.UnitedStates,
} as const;

export const CurrencyCountry = {
  [Currency.Australia]: Country.Australia,
  [Currency.Canada]: Country.Canada,
  [Currency.Malaysia]: Country.Malaysia,
  [Currency.NewZealand]: Country.NewZealand,
  [Currency.Qatar]: Country.Qatar,
  [Currency.SaudiArabia]: Country.SaudiArabia,
  [Currency.Singapore]: Country.Singapore,
  [Currency.UnitedArabEmirates]: Country.UnitedArabEmirates,
  [Currency.UnitedKingdom]: Country.UnitedKingdom,
  [Currency.UnitedStates]: Country.UnitedStates,
} as const;

export const CurrencyCountryLocale = {
  [Currency.Australia]: 'au',
  [Currency.Canada]: 'ca',
  [Currency.Malaysia]: 'my',
  [Currency.NewZealand]: 'nz',
  [Currency.Qatar]: 'qa',
  [Currency.SaudiArabia]: 'sa',
  [Currency.Singapore]: 'sg',
  [Currency.UnitedArabEmirates]: 'ae',
  [Currency.UnitedKingdom]: 'gb',
  [Currency.UnitedStates]: 'us',
} as const;

export const CurrencyIcons = {
  [Country.Australia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/AUD.jpg',
  [Country.Canada]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/CAD.svg',
  [Country.Malaysia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/MYR.jpg',
  [Country.NewZealand]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/NZD.svg',
  [Country.Qatar]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/QAR.svg',
  [Country.SaudiArabia]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/SAR.svg',
  [Country.Singapore]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/SGD.jpg',
  [Country.UnitedArabEmirates]:
    'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/AED.svg',
  [Country.UnitedKingdom]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/GBP.svg',
  [Country.UnitedStates]: 'https://skin-seoul.com/wp-content/themes/hello-elementor-child/imgs/country-flags/USD.jpg',
};
